module.exports = __webpack_public_path__ + "static/media/ponte_tn.8c34112a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/ponte_tn.jpg
// module id = 682
// module chunks = 0